/* global axios */
import ApiClient from './ApiClient';

class WacallsCallAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getUrl(conversationId) {
    return `${this.url}/${conversationId}/wacalls_call`;
  }

  start(conversationId) {
    return axios.post(this.getUrl(conversationId));
  }

  webrtc(conversationId, { call_id, sdp_offer }) {
    return axios.post(`${this.getUrl(conversationId)}/webrtc`, {
      call_id,
      sdp_offer,
    });
  }

  terminate(conversationId, { call_id }) {
    return axios.post(`${this.getUrl(conversationId)}/terminate`, { call_id });
  }

  accept(conversationId, { call_id }) {
    return axios.post(`${this.getUrl(conversationId)}/accept`, { call_id });
  }
}

export default new WacallsCallAPI();
